// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1xKMP","messages":"Chat_messages__2DZ9a","dateDivider":"Chat_dateDivider__3ct6E"};